{
  "id": 17,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 15,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "macaron", "count": 20 }
  ],
  "stars": [2280, 3180],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". x . x . x . x",
    "x . x . x . x .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.857, "movesLeft": 4.9, "closeLosses": 0.082, "target": 0.8 }
}
